import React from 'react';

interface AppContextProviderProps {
  children: React.ReactNode;
}

// AppContextProvider is now a simple wrapper since useAppContext
// handles all the context logic including setting data-app-context
export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
  return <>{children}</>;
}; 